import React, { useState, useRef, useEffect, useCallback } from "react";
import InfoIcon from "@mui/icons-material/InfoOutlined";

const Tooltip = ({ text, children, className }) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const tooltipRef = useRef(null);
  const triggerRef = useRef(null);

  useEffect(() => {
    if (showTooltip && tooltipRef.current && triggerRef.current) {
      const triggerRect = triggerRef.current.getBoundingClientRect();
      const tooltip = tooltipRef.current;

      tooltip.style.left = `${triggerRect.left + triggerRect.width / 2}px`;
      tooltip.style.top = `${triggerRect.top - tooltip.offsetHeight - 8}px`;
      tooltip.style.transform = "translateX(-50%)";
    }
  }, [showTooltip]);

  const handleMouseEnter = useCallback(() => setShowTooltip(true), []);
  const handleMouseLeave = useCallback(() => setShowTooltip(false), []);

  return (
    <>
      <div
        ref={triggerRef}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        className="cursor-help inline-flex items-center "
      >
        {children}
      </div>
      {showTooltip && (
        <div
          ref={tooltipRef}
          className={`fixed flex px-3 py-2 bg-primary text-white text-[9px] rounded-lg shadow-xl z-[9999] pointer-events-none whitespace-normal h-fit max-w-[250px] ${className} `}
          style={{
            transform: "translateX(-50%)",
          }}
        >
          <InfoIcon className="text-[8px] text-white mr-2" />
          {text}
          <div className="absolute top-full left-1/2 transform -translate-x-1/2 -mb-1 border-4 border-transparent border-t-surface"></div>
        </div>
      )}
    </>
  );
};

export default Tooltip;
